import {UserModel} from '@/models/user.model';
import {BaseApi} from '@/api/base.api';

export class LeagueApi extends BaseApi<UserModel> {
  constructor() {
    super('league/meet-the-league')
  }
}
